/**
 * Плагин: при удалении node с графа удаляем узел из модели и шлём patch removeNode.
 * Срабатывает при действии пользователя (контекстное меню «Удалить с диаграммы»).
 * При применении удаления по патчу из сокета сначала вызывается removeFromParent — узел убирается
 * из модели, затем graph.removeCell(cell) без silent (чтобы view обновился). Событие node:removed
 * при этом срабатывает, но _findViewElementById(id) уже возвращает null, поэтому патч не отправляется.
 */
import * as viewElements from '../modelerX6/viewElements';

export default {
	init(modeler, context) {
		const {graph, onPatch, viewIndex} = context;
		const VIEW_INDEX = viewIndex ?? 0;

		const onNodeRemoved = args => {
			if (modeler._applyingPatch) return;
			const cell = args?.node ?? args?.cell;
			if (!cell) return;
			const id = typeof cell === 'string' ? cell : cell?.id;
			if (!id) return;
			if (modeler.isLockedByOther?.(id)) return;
			const viewElement = modeler._findViewElementById(id);
			if (!viewElement) return;
			viewElements.removeViewElementById(modeler, id);
			onPatch({
				patches: [{op: 'removeNode', viewIndex: VIEW_INDEX, identifier: id}],
			});
		};

		graph.on('node:removed', onNodeRemoved);

		return () => graph.off('node:removed', onNodeRemoved);
	},
};
